

import {useEffect, useState} from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-cover.jpeg";
// import { useLocation, useHistory } from "react-router-dom";
// import {  } from "react-router-dom";
import MDSnackbar from "../../../../components/MDSnackbar";
// import MDAlert from "../../../../components/MDAlert";
import {getUserIsLogin, login} from "../../../../services/auth.service";
import CoreService from "../../../../services/core.service";
import { useCookies } from "react-cookie";
import Modal from "@mui/material/Modal";
import {modalStyleUser} from "../../../../components/Utils/ModalStyle";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import Icon from "@mui/material/Icon";

function Cover() {
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [infoSB, setInfoSB] = useState(false);
  const openInfoSB = () => setInfoSB(true);
  const closeInfoSB = () => setInfoSB(false);
  const [errorSB, setErrorSB] = useState(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  // const [cookies, setCookie] = useCookies(["Authorization"]);
  const [isFirstImpression, setIsFirstImpression] = useState(false);


  useEffect(() => {
    if (localStorage.getItem("first_impression") === null){
      localStorage.setItem("first_impression", true);
      setIsFirstImpression(true);
    }else{
      setIsFirstImpression(false);
    }
  }, [setIsFirstImpression])

  const loadWellcomeModal = () => {

    return (<Dialog
          open={isFirstImpression}
          keepMounted
          onClose={()=>setIsFirstImpression(false)}
          aria-describedby="alert-dialog-slide-description" >
          <DialogTitle>
              Welcome To New Amenity Booking Panel
          </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
            Dear valued client,<br/>
            We have updated our system.<br/>
            To be able to log in for the first time, you should change the password. <br/>
            You can click on the link previously sent to your email or use the link below.<br/>
            Thank you and have fun.<br/>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={()=>setIsFirstImpression(false)} size={"large"} color={"info"} >Ok</MDButton>
      </DialogActions>
    </Dialog>)

  }



  // const loading = () => setLoading(false);

  // if (getUserIsLogin()) {
  //   navigate("/dashboard");
  // }

  const renderInfoSB = (
    <MDSnackbar
      icon="notifications"
      title="Amenity System"
      content="Your logged in successfully"
      dateTime=""
      open={infoSB}
      onClose={closeInfoSB}
      close={closeInfoSB}
    />
  );
  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Amenity System"
      content="Username or password was incorrect"
      dateTime=""
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );
  const onChangeUsername = (e) => {
    setUsername(e.target.value);
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);
    console.log("login");
    login(username, password).then(
      (data) => {
        // Set the Authorization cookie from the barrier token returned by the API
        // The barrier value already includes "Barrier " prefix from the backend
        // Replace space with + because the backend ExtractToken expects "Barrier+TOKEN" format
        const barrierValue = data.data["barrier"];

        const host = window.location.hostname;
        const isLocalhost =
          host === "localhost" ||
          host === "127.0.0.1" ||
          host.endsWith(".localhost");

        // if (isLocalhost) {
        //   document.cookie = `Authorization=${barrierValue}; path=/; max-age=${60 * 60 * 24 * 144}; SameSite=Lax`;
        // } else {
        //   document.cookie = `Authorization=${barrierValue}; path=/; max-age=${60 * 60 * 24 * 144}; domain=.amenitybooking.ca; Secure; SameSite=None`;
        // }

        //document.cookie =  `Authorization=${barrierValue}; path=/; max-age=${60 * 60 * 24 * 144}; domain=.amenitybooking.ca; SameSite=Lax`;
        //document.cookie = `Authorization=${barrierValue}; path=/; max-age=${60 * 60 * 24 * 144}`;
        
        console.log("AFTER SET COOKIE:", document.cookie);

        setLoading(false);
        [
          "Authentication",
          "permission",
          "avatar",
          "nick_name",
          "first_name",
          "last_name",
          "email",
          "unit",
          "client",
          "building",
          "client___1",
        ].forEach((key) => localStorage.removeItem(key));

        localStorage.setItem("Authentication",  data.data["barrier"])
        localStorage.setItem("permission", data.data["role"]);
        if (data.data["avatar"]) {
          localStorage.setItem("avatar", CoreService.BASE_API_URL + data.data["avatar"]);
        }
        localStorage.setItem("nick_name", data.data["nick_name"]);
        localStorage.setItem("first_name", data.data["first_name"]);
        localStorage.setItem("last_name", data.data["last_name"]);
        localStorage.setItem("email", data.data["email"]);
        localStorage.setItem("unit", data.data["unit"]);
        localStorage.setItem("client", data.data["client"]);
        localStorage.setItem("building", data.data["building"] || "");
        localStorage.setItem("client___1", data.data["client"]);
        openInfoSB();
        window.location.replace("/dashboards");
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
          openErrorSB();
          setLoading(false);
          localStorage.setItem("permission", "");
          // setErrorType("danger");
          //console.log(resMessage);
          // setErrorMessage("username or password was incorrect !");
        // showNotification();
      }
    );
  };
  const handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      handleLogin(event)
    }
  }
  return (
    <CoverLayout image={bgImage}>
      {/*{loadWellcomeModal()}*/}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="warning"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Enter your username and password to Sign In
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" onSubmit={handleLogin} role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Username"
                variant="standard"
                onChange={onChangeUsername}
                fullWidth
                placeholder="username"
                InputLabelProps={{ shrink: true, required: true }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="standard"
                fullWidth
                onKeyPress={handleKeyPress}
                onChange={onChangePassword}
                placeholder="************"
                InputLabelProps={{ shrink: true, required: true }}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                onClick={handleLogin}
                disabled={loading}
                variant="gradient"
                color="warning"
                fullWidth
              >
                Sign In
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography
                component={Link}
                to="/authentication/reset_password"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                Forgot Password?
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
        {renderInfoSB}
        {renderErrorSB}
      </Card>
    </CoverLayout>
  );
}

export default Cover;
